/*
 * Product card size chips.
 * Chip clicks swap the variant id on the card's add-to-cart form (the theme's
 * <product-form> element handles the AJAX add itself).
 */
(function () {
  function selectChip(chip) {
    const wrapper = chip.closest('.m-pcard-buy');
    if (!wrapper || chip.dataset.available !== 'true') return;

    wrapper.querySelectorAll('[data-pcard-chip]').forEach((el) => {
      const selected = el === chip;
      el.classList.toggle('is-selected', selected);
      el.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    const input = wrapper.querySelector('[data-pcard-variant-input]');
    if (input) input.value = chip.dataset.variantId;

    // keep the card price in step with the chosen size, sale or not
    const card = wrapper.closest('.m-product-card');
    const priceWrap = card && card.querySelector('.m-product-card__price .m-price');
    if (!priceWrap || !chip.dataset.price) return;

    const onSale = chip.dataset.onSale === 'true';
    priceWrap.classList.toggle('m-price--on-sale', onSale);

    if (onSale) {
      const saleEl = priceWrap.querySelector('.m-price__sale .m-price-item--sale');
      const wasEl = priceWrap.querySelector('.m-price__sale .m-price-item--regular');
      if (saleEl) saleEl.innerHTML = chip.dataset.price;
      if (wasEl && chip.dataset.comparePrice) wasEl.innerHTML = chip.dataset.comparePrice;
    } else {
      const regularEl = priceWrap.querySelector('.m-price__regular .m-price-item--regular');
      if (regularEl) regularEl.innerHTML = chip.dataset.price;
    }
  }

  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-pcard-chip]');
    if (!chip) return;
    event.preventDefault();
    selectChip(chip);
  });
})();
